import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default {
    bind(el, binding) {
        tippy(el, {
            content: binding.value,
            placement: 'top',
            zIndex: 9999,
        });
    },
};
